import React, {FC} from "react";
import useCustomer from "../../../hooks/use-customer";
import VidaHeader from "../vida-header";
import UsingVida from "../../../pages/vida/ir-workshop-instructional-library/using-vida";
import SPAPlatformAndLaterWiringDiagrams
  from "../../../pages/vida/ir-workshop-instructional-library/spa-platform-and-later-wiring-diagrams";
import SPAPlatformAndLaterVDSFaultTracing
  from "../../../pages/vida/ir-workshop-instructional-library/spa-platform-and-later-vds-fault-tracing";
import SoftwareDownload from "../../../pages/vida/ir-workshop-instructional-library/software-download";
import PlatformIdentification from "../../../pages/vida/ir-workshop-instructional-library/platform-identification";
import NetworkFaultTracingOverview
  from "../../../pages/vida/ir-workshop-instructional-library/network-fault-tracing-overview";
import ModuleRecoveryGeneral from "../../../pages/vida/ir-workshop-instructional-library/module-recovery-general";
import ConnectingP3VehiclesAndPreviousUsingDice
  from "../../../pages/vida/ir-workshop-instructional-library/connecting-p3-vehicles-and-previous-using-dice";
import ConnectingSpaOrCmaPlatformVehicles
  from "../../../pages/vida/ir-workshop-instructional-library/connecting-spa-or-cma-platform-vehicles";

const IRWorkshopInstructionalLibrary: FC = () => {
  const customer = useCustomer();

  const hasAccess = () => {
    if (customer) { // user exists
      // user is an admin or internal user
      if (customer.customer!.permissions.some((p) => p === 'system_admin' || p === 'internal_access')) {
        return true;
      }

      // user has vidaId subscription
      if (customer.customer!.attributes.some((a) => a.code === 'vidaId' && a.value.length > 0)) {
        return true;
      }
    }

    return false;
  }

  return <div className="vida-content">
    <VidaHeader>IR Workshop Instructional Library</VidaHeader>
    {!hasAccess()
      ?
      <div className="no-vida-id">
        <p>IR Workshop Instructional Library is only available to active VIDA subscribers.</p>
      </div>
      :
      <>
        <UsingVida/>
        <SPAPlatformAndLaterWiringDiagrams/>
        <SPAPlatformAndLaterVDSFaultTracing/>
        <SoftwareDownload/>
        <PlatformIdentification/>
        <NetworkFaultTracingOverview/>
        <ModuleRecoveryGeneral/>
        <ConnectingP3VehiclesAndPreviousUsingDice/>
        <ConnectingSpaOrCmaPlatformVehicles/>
      </>
    }
    <style jsx>{`
      .vida-content {
        padding: 2rem 3rem;
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        min-height: 40rem;
      }

      .no-vida-id {
        text-align: center;
        margin: 2em auto;
      }

      strong {
        font-weight: 500;
      }

      .links {
        display: grid;
        align-items: center;
      }

      .links > :global(a) {
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        text-decoration: none;
        color: #333;
        padding: 1rem;
        margin-bottom: 0.5rem;
        cursor: pointer;
      }

      .links > :global(a:hover) {
        background-color: #eee;
      }

      .click-icon {
        float: left;
        padding-right: 2rem;
      }
    `}</style>
  </div>
}

export default IRWorkshopInstructionalLibrary;
